const ACCOUNTS = {
  INVENTORY_ID: "",
  DIRECT_INCOME_ID: "6f1bf475-c107-4fb0-af97-248c142006a8",
  DIRECT_EXPENSES_ID: "0b73537a-ee98-4d9b-8705-a8dc3b2d9648",
  INCOME_ID: "f8e9d0a1-2b3c-4d5e-6f7a-8b9c0d1e2f3a",
  EXPENDITURE_ID: "c3d4e5f6-7a8b-9c0d-1e2f-3a4b5c6d7e8f",
  CASH_ID: "21ae21a9-4b3d-4850-b06a-da41422a52be",
  BANK_ID: "407cc0e0-383d-4b06-92bd-3bcb98ae43af",
  SUNDRY_DEBTORS: "a17de76c-e2bf-4db1-9fbb-908002c43473",
  SUNDRY_CREDITORS: "d4e5f6a7-8b9c-4d1e-2f3a-5b6c7d8e9f0a",
};
export default ACCOUNTS;
